import { render, staticRenderFns } from "./SueldoUsuarios.vue?vue&type=template&id=51674fb6&"
import script from "./SueldoUsuarios.vue?vue&type=script&lang=js&"
export * from "./SueldoUsuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports